<template>
    <div>

        <form class="item-editor-form">
            
            <div class="deviation-container" >

                <div class="color-box">
                    <label > {{ $t('deviation_settings.too_early') }} </label>
                    <button :style="{ 'background-color': this.localObject[0].primarycolor }" @click.prevent="showModal(0)"> {{ $t('deviation_settings.choose_color') }} </button>
                </div>

                <div class="number-box">
                    <label> {{ $t('deviation_settings.seconds') }} </label>
                    <b-form-input type="number" v-model.number="localObject[1].minval" @change="secondChanged(1)" />
                </div>

                <div class="color-box">
                    <label> {{ $t('deviation_settings.early') }} </label>
                    <button :style="{ 'background-color': this.localObject[1].primarycolor  }" @click.prevent="showModal(1)"> {{ $t('deviation_settings.choose_color') }} </button>
                </div>

                <div class="number-box">
                    <label> {{ $t('deviation_settings.seconds') }} </label>
                    <b-form-input type="number" v-model.number="localObject[2].minval" @change="secondChanged(2)" />
                </div>

                <div class="color-box">
                    <label> {{ $t('deviation_settings.on_time') }} </label>
                    <button :style="{ 'background-color': this.localObject[2].primarycolor }" @click.prevent="showModal(2)"> {{ $t('deviation_settings.choose_color') }} </button>
                </div>

                <div class="number-box">
                    <label> {{ $t('deviation_settings.seconds') }} </label>
                    <b-form-input type="number" v-model.number="localObject[3].minval" @change="secondChanged(3)" />
                </div>

                <div class="color-box">
                    <label> {{ $t('deviation_settings.small_delay') }} </label>
                    <button :style="{ 'background-color': this.localObject[3].primarycolor }" @click.prevent="showModal(3)"> {{ $t('deviation_settings.choose_color') }} </button>
                </div>

                <div class="number-box">
                    <label> {{ $t('deviation_settings.seconds') }} </label>
                    <b-form-input type="number" v-model.number="localObject[4].minval" @change="secondChanged(4)" />
                </div>

                <div class="color-box">
                    <label> {{ $t('deviation_settings.big_delay') }} </label>
                    <button :style="{ 'background-color': this.localObject[4].primarycolor }" @click.prevent="showModal(4)"> {{ $t('deviation_settings.choose_color') }} </button>
                </div>

            </div>

            <FormButtons
                @submit="submit"
                :reset="true" 
                :remove="false"
                class="formButtons"
                @reset="reset">
            </FormButtons>

            <RequestInfo :ok="ok" :error="error" :loader="loading" />

            <b-modal 
                id='color-modal' 
                :title="$t('deviation_settings.choose_color')"
                class="color-modal"
                hide-footer >
		<swatches-picker
			v-model="selectedColor"
			@input="colorChanged"
		/>
            </b-modal>  

        </form> 	

    </div>

</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import deviationcolors from '@/store/system/deviationColors'
import { Swatches } from 'vue-color'

export default {
  name: 'DeviationColorsEditor',
  components:{
	FormButtons,
	'swatches-picker': Swatches
  },
  data() {
      return {
            ok: false,
            selectedColor: "#FF0000",
            error: false,
            loading: false,
            selectedClass: null,
            localObject: [
            {
              "class":0,
              "minval": 0,
              "maxval": 0,
              "primarycolor": "#ffffff",
            },
            {
              "class":1,
              "minval": 0,
              "maxval": 0,
              "primarycolor": "#ffffff",
            },
            {
              "class":2,
              "minval": 0,
              "maxval": 0,
              "primarycolor": "#ffffff",
            },
            {
              "class":3,
              "minval": 0,
              "maxval": 0,
              "primarycolor": "#ffffff",
            },
            {
              "class":4,
              "minval": 0,
              "maxval": 0,
              "primarycolor": "#ffffff",
            }
          ]
      }
  },
  created() {
    if (!this.$store.state.deviationcolors) {
            this.$store.registerModule("deviationcolors" , deviationcolors);
        }
    this.$store.dispatch('deviationcolors/getDeviationColors').then(
        (data) => {
            this.localObject = data;
        }
    );
    this.$bvModal.show('color-modal')
  },
  methods: {
       submit(event) {
           if( event ) 
                event.preventDefault(); 

            setTimeout(() => { 
                this.$store.dispatch('deviationcolors/updateDeviationColors' , this.localObject).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);

        },
        reset(event){
            if( event ) 
                event.preventDefault();

            this.$store.dispatch('deviationcolors/getDeviationColors').then(
                    (data) => {
                        this.localObject = data;
                    }
                );
        },
        showModal(id){
            if(id != null){
                this.selectedClass = id;
                this.$bvModal.show('color-modal')
                this.selectedColor = this.localObject[id].primarycolor;
            }
        },
        colorChanged(){
            if(this.selectedClass != null){
                    this.localObject[this.selectedClass].primarycolor = this.selectedColor.hex;
                    this.$bvModal.hide('color-modal')
            }
        },
        secondChanged(classId){
            this.localObject[classId-1].maxval = this.localObject[classId].minval - 1;
        }
  }
}
</script>
<style lang="scss">
div.vc-swatches {
	width: initial;
	height: initial;
	overflow: hidden;
}

</style>

<style scoped lang="scss">


.formButtons {
    display: flex;
    justify-content: flex-end;
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.color-modal {
        width: 100%;

        v-color-picker {
            margin: auto;
            width: 100%;
        }
}

.deviation-container  {
    display: flex;
    width: 100%;
    flex-direction: row;
}

.color-box { 
    display: flex;
    flex-direction: column;
    flex: 4;

    button {
        width: fit-content;
        padding: 10%;
        border-radius: 4px;
        border: 1px solid black;
        margin: auto;
    }

    label {
        font-size: 110%;
        text-align: center;
        width: 100%;
    }
}

.number-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-bottom: auto;
    margin-top: auto;

    input {
       width: 100%;
       text-align: center;
       border: 1px black solid;
    }

    label {
        font-size: 90%;
        text-align: center;
        width: 100%;
        height: fit-content;
        margin: 0;
    }
}

</style>
